import React, { useState } from 'react';
import ProfileImageView from '../ProfileImageView';
import { CaretDownOutline } from 'react-ionicons';
import { useAppSelector } from 'src/app/services/store';
import { getCurrentChild, getCurrentNursery, getIsEyengageFilterApplied, getShowDownloadAppBanner } from 'src/shared/redux-state/src';
import { FilterIcon } from 'src/app/static/images/svg';
import { EyengageFilterModal, NurseryListModal } from '../../modals';
import NotificationBell from '../NotificationBell';
import DownloadAppBanner from '../DownloadAppBanner';
import { ChildrenStoreData } from 'src/shared/types/src';

type NurseryHeaderProps = {
  showFilter?: boolean
}

const NurseryHeader: React.FC<NurseryHeaderProps> = ({ showFilter = true }) => {
  const currentNursery = useAppSelector(getCurrentNursery);
  const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);
  const isEyengageFilterApplied = useAppSelector(getIsEyengageFilterApplied);
  const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);

  const [isNurseryListModal, setIsNurseryListModal] = useState<boolean>(false);
  const [isFilterModal, setIsFilterModal] = useState<boolean>(false);

  const toggleNurseryListModal = () => {
    setIsNurseryListModal(!isNurseryListModal);
  }

  const toggleFilterModal = () => {
    setIsFilterModal(!isFilterModal);
  }

  return (
    <>
      <div className={`header ${showDownloadAppBanner ? 'h-auto' : ''}`}>
        {showDownloadAppBanner ? <DownloadAppBanner /> : null}
        <div className='container h-100'>
          <div className='row align-items-center h-100'>
            <div className='col-8'>
              <div className='d-flex align-items-center'>
                <ProfileImageView
                  name={currentNursery?.name}
                  imageUrl={currentNursery?.logo}
                  resizeMode='contain'
                  customContainerStyles='border-gray-600'
                />
                <div className='avatar-details avatar-details-w32'>
                  <p onClick={toggleNurseryListModal} className='avatar-name mb-0 text-black d-flex cursor-pointer'>
                    <span className='text-ellipsis fs-6 fw-semibold d-inline-block me-1'>
                      {currentNursery?.name}
                    </span>
                    <CaretDownOutline
                      color={'#000000'}
                      height="12px"
                      width="12px"
                    />
                  </p>
                </div>
              </div>
            </div>
            <div className='col-4'>
              <div className='d-flex align-items-center justify-content-end mx-n-8'>
                {showFilter && Boolean(currentChild?.systemsEnabled?.eyengage) ?<div className='px-2 cursor-pointer' onClick={toggleFilterModal}>
                  <div className='d-flex position-relative cursor-pointer'>
                    <span><FilterIcon /></span>
                    {isEyengageFilterApplied ? <span className="filter-badge"></span> : null}
                  </div>
                </div> : null}
                <NotificationBell />
              </div>
            </div>
          </div>
        </div>
      </div>

      {isNurseryListModal && <NurseryListModal
        isNurseryListModal={isNurseryListModal}
        toggleNurseryListModal={toggleNurseryListModal}
      />}

      {isFilterModal && <EyengageFilterModal
        isOpen={isFilterModal}
        toggleModal={toggleFilterModal}
      />}

    </>
  );
};

export default NurseryHeader;
